import axios from 'axios';
const CONTROLLER_PATH = 'User/';
class UserService {
    getAll() {
        return axios.get(CONTROLLER_PATH + 'Get').then((response) => response.data);
    }
    getOne(userId) {
        return axios.get(CONTROLLER_PATH + 'Get/' + userId).then((response) => response.data);
    }
    getSet(userIds) {
        return axios.post(CONTROLLER_PATH + 'GetUsers', userIds).then((response) => response.data);
    }

    getAccisureReps() {
        return axios.get(CONTROLLER_PATH + 'GetAccisureReps').then((response) => response.data);
    }
    
    update(user) {
        return axios.post(CONTROLLER_PATH + 'Update', user).then((response) => response.data);
    }
    delete(user) {
        return axios.post(CONTROLLER_PATH + 'Delete', user).then(() => {});
    }
    add(user) {
        return axios.post(CONTROLLER_PATH + 'Add', user).then((response) => response.data);
    }
    resetPassword(userId) {
        return axios.get(CONTROLLER_PATH + 'ResetPassword/' + userId).then((response) => response.data);
    }
}

export default new UserService();
